import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { OutlinedBtnPrimary, SectionTitle } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useExportProgramacaoExcelState, {
  EXPORT_PROGRAMACAO_EXCEL_ACTIONS,
} from './ExportProgramacaoExcelState'

export default connect()(ExportProgramacaoExcel)

function ExportProgramacaoExcel({ ciclo, dispatch }) {
  const { state, actions } = useExportProgramacaoExcelState(ciclo)

  useEffect(() => {
    switch (state.loading) {
      case EXPORT_PROGRAMACAO_EXCEL_ACTIONS.LOADING_DELIVERY_ITEMS:
        dispatch(showLoadingBox('Obtendo a Programação de Entrega', 'Aguarde . . .'))
        break
      case EXPORT_PROGRAMACAO_EXCEL_ACTIONS.EXPORTANDO_PROGRAMACAO:
        dispatch(showLoadingBox('Exportando a Programação de Entrega', 'Aguarde . . .'))
        break
      default:
        dispatch(hideLoadingBox())
        break
    }
  }, [state.loading])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      actions.resetMessages()
    state.successMessage &&
      dispatch(showMessageBox(state.successMessage, null)) &&
      actions.resetMessages()
  }, [state.errorMessage, state.successMessage])

  // Render
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Exportar Programação - Excel" />
      </div>
      <div className="p-col-12">
        <OutlinedBtnPrimary label="Exportar Excel" onClick={actions.onBtnExportarClick} />
      </div>
      <div className="p-col-12">
        <DataTable
          value={state.delivery_items}
          emptyMessage="Programação de Entrega NÃO encontrada. Verifique se as informações de entrega foram importadas"
          rows={10}
          paginator
        >
          <Column field="company_name" header="Empresa" />
          <Column field="cnpj_emissor" header="Empresa CNPJ" />
          <Column field="nome_fantasia" header="Cliente" />
          <Column field="cnpj" header="Cliente CNPJ" />
          <Column field="produto_codigo" header="Código" />
          <Column field="produto_nome" header="Produto" />
          <Column field="qte" header="Qte. Caixa" />
          <Column field="peso" header="Peso" />
        </DataTable>
      </div>
    </div>
  )
}
